import React from 'react';
import { Global, css } from '@emotion/react';
import vars from './variables';

const GlobalStyles: React.FC = () => {
  return (
    <Global
      styles={css`
        * {
          font-family: ${vars.primaryFontFamily};
          color: ${vars.coreDarkGrey};
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        font {
          color: inherit;
        }
        body {
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          text-rendering: optimizeLegibility;
          overflow-x: hidden;
        }
        html {
          font-size: 62.5%;
          line-height: 1.2;

          @media screen and (max-width: ${vars.breakPointMinWidth}) {
            min-width: ${vars.breakPointMinWidth};
            overflow-x: scroll;
          }

          .italic {
            font-style: italic;
          }

          .underline {
            text-decoration: underline;
          }

          .font-weight-1,
          .font-weight-1 .underline,
          .font-weight-1 .italic {
            font-weight: ${vars.fontWeightBold};
          }
        }

        .disable-scroll {
          overflow: hidden;
        }
      `}
    />
  );
};

export default GlobalStyles;
